<template>
  <div class="hs-business-icon">
    <img :src="iconUrl" alt="">
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    // 业务板块
    OrderBusinessType: { // 1 机票 6 国际机票 2 酒店 11 海外酒店  10火车票 14用车 17 需求单
      type: Number,
      default: 0
    },
  },
  computed: {
    iconUrl() {
      let iconObj = {
        1: 'icons_40pt_Air_tickets@3x.png',
        6: 'icons_40pt_Air_tickets@3x.png',
        2: 'icons_40pt_hotel@3x.png',
        11: 'icons_40pt_hotel@3x.png',
        10: 'icons_40pt_train_ticket@3x.png',
        14: 'icons_40pt_car@3x.png',
        17: 'icons_40pt_Air_tickets@3x.png',
      }
      return require('@/assets/image/home/' + iconObj[this.OrderBusinessType || 1])
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-business-icon
  display inline-flex
  flex-shrink 0
  width 24px
  height 24px
  margin-right 4px
  img
    width 100%
    height 100%
</style>
